// Date helpers wrapping date-fns with the Czech locale baked in.
// Use these instead of importing `date-fns` directly so locale is consistent
// app-wide and the helper signatures are stable across feature code.

import {
  addDays,
  format as dfFormat,
  formatDistance as dfFormatDistance,
  formatRelative as dfFormatRelative,
  parseISO,
  isValid,
  subHours,
} from "date-fns";
import { cs } from "date-fns/locale";

const LOCALE = { locale: cs };

export function formatDate(value: Date | string, pattern = "d. MMMM yyyy"): string {
  const d = typeof value === "string" ? parseISO(value) : value;
  if (!isValid(d)) return "";
  return dfFormat(d, pattern, LOCALE);
}

export function formatDateTime(value: Date | string): string {
  return formatDate(value, "d. MMMM yyyy HH:mm");
}

export function formatTime(value: Date | string): string {
  return formatDate(value, "HH:mm");
}

export function formatRelative(value: Date | string, base: Date = new Date()): string {
  const d = typeof value === "string" ? parseISO(value) : value;
  if (!isValid(d)) return "";
  return dfFormatRelative(d, base, LOCALE);
}

export function formatDistanceFromNow(value: Date | string, opts?: { addSuffix?: boolean }): string {
  const d = typeof value === "string" ? parseISO(value) : value;
  if (!isValid(d)) return "";
  return dfFormatDistance(d, new Date(), { ...LOCALE, addSuffix: opts?.addSuffix ?? true });
}

export { addDays, parseISO, isValid, subHours };
